import * as React from 'react';
import { attachBehaviors } from './BehaviorsHelper';
import { CalendarDayContentConfig } from '../interfaces/CalendarDayConfig';
import { logMountingPerformance } from 'owa-analytics';
import { observer } from 'mobx-react';

let styles = require('./CalendarDayList.scss');

/**
 * Props for calendar grid
 */
export interface CalendarGridProps {
    contentConfig: CalendarDayContentConfig;
}

/**
 * The control is showing in day events on grid.
 */
@logMountingPerformance('CalendarGrid')
@observer
export default class CalendarGrid extends React.Component<CalendarGridProps, {}> {
    render() {
        let { contentConfig } = this.props;
        let surfaceItems = contentConfig.content.content();
        let gridLineRows = contentConfig.content.gridLines();

        return attachBehaviors(
            <div className={styles.renderPanel} key="surfaceRenderPanel_2">
                {gridLineRows}
                {surfaceItems}
            </div>,
            (contentConfig.renderInDayBehaviors && contentConfig.renderInDayBehaviors) || []
        );
    }
}
